import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

import { useYearlyVacationBalanceTable } from '~/scenes/PeopleModule/components/Tabs/AbsencesTab/components/VacationBalanceData/YearlyVacationBalanceTable/useYearlyVacationBalanceTable';

import { useSxStyles } from './useStyles';

export const YearlyVacationBalanceTable = () => {
  const { t } = useTranslation();
  const sxStyles = useSxStyles();

  const { isEnabled, yearlyBalanceRows } = useYearlyVacationBalanceTable();

  return isEnabled ? (
    <TableContainer component={Paper} variant={'outlined'} sx={sxStyles.paper}>
      <Table size={'small'}>
        <TableHead>
          <TableRow>
            <TableCell colSpan={6}>{t('yearlyVacationBalances')}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>{t('laYear')}</TableCell>
            <TableCell>{t('laAbsenceReason')}</TableCell>
            <TableCell>{t('laBalance')}</TableCell>
            <TableCell>{t('laInProgress')}</TableCell>
            <TableCell>{t('laApproved')}</TableCell>
            <TableCell>{t('laRemaining')}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {yearlyBalanceRows.map((data, index) => {
            return (
              <TableRow key={index}>
                <TableCell>{data.year}</TableCell>
                <TableCell>{data.reason}</TableCell>
                <TableCell align={'right'}>{data.balance}</TableCell>
                <TableCell align={'right'}>{data.proposed}</TableCell>
                <TableCell align={'right'}>{data.approved}</TableCell>
                <TableCell align={'right'}>{data.remaining}</TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  ) : (
    <></>
  );
};
